
seedWebControllers.controller('IntegrationScopesController', ['$scope', '$location', '$routeParams', 'IntegrationScopeService', 'ToastService', '$mdDialog', '$uibModal', '$rootScope',
    function ($scope, $location, $routeParams, IntegrationScopeService, ToastService, $mdDialog, $uibModal, $rootScope) {
        console.log('IntegrationScopes');

        $scope.moduleName = 'Integrations';
        $scope.statusFilter = 'Todas';

        $scope.integrationID = $routeParams.id;
        $scope.isBusy = false;

        $scope.disableAddNew = function () {
            var disableds = [];
            disableds.push('IMP_GENESIS_ALTERA_PRE_VENDA');
            disableds.push('IMP_GENESIS_PRECO');
            for (var i in disableds) {
                if ($scope.integrationID == disableds[i]) {
                    return true;
                }
            }
            return false;
        };

        $scope.filter = function () {
            $scope.loadIntegrationScopes(true);  
        };

        $scope.loadIntegration = function () {
            $scope.isBusy = true;
            IntegrationScopeService.getIntegration($scope.integrationID).then(function (result) {                
                $scope.listItem = result.data;
                $scope.loadIntegrationScopes();             
            }, function () {
                $scope.isBusy = false;
            });
        };

        $scope.editModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Integrations/EditAdminIntegration.html',
                controller: 'EditAdminIntegrationCtrl',
                size: 'lg',
                resolve: {
                    integrationID: function () { return $scope.listItem.IntegrationID; }
                }
            });

            modalInstance.result.then(function (action) {

                if (action == 'DELETE') {
                    ToastService.createToast('Integração deletada com sucesso!', '', 8000, 'success');
                    $scope.goList();
                }  else {
                    ToastService.createToast('Integração salva com sucesso!', '', 4000, 'success'); 
                    $scope.reload();
                }

            });

        };

        $scope.skipNumber = 0;
        $scope.takeNumber = 25;

        $scope.loadIntegrationScopes = function (fullReload) {
            $scope.isBusy = true;
            if (fullReload) {
                $scope.skipNumber = 0;
                $scope.noMoreData = false;
            }
            var errorOnly = false;
            if ($scope.statusFilter === 'Com Erros') {
                errorOnly = true;
            }

            console.log('loadScopes');
            IntegrationScopeService.getIntegrationScopes($scope.integrationID, $scope.skipNumber, $scope.takeNumber, errorOnly).then(function (result) {
                var data = result.data;
                if ($scope.listItem.Scopes && !fullReload) {
                    $scope.listItem.Scopes = $scope.listItem.Scopes.concat(data);
                    //$scope.integrationScopeQueues = $scope.integrationScopeQueues.concat(data);
                }
                else {
                    $scope.listItem.Scopes = angular.copy(data);
                }                

                $scope.skipNumber += data.length;

                if (data.length === 0) {
                    $scope.noMoreData = true;   
                }

                $scope.isBusy = false;

                console.log('loadScopes - OK');
            }, function () {
                $scope.isBusy = false;
                $scope.noMoreData = true;   
                console.log('loadScopes - ERROR');
            });

        };

        $scope.loadIntegration();

        $scope.reload = function () {
            $scope.takeNumber = 25;
            IntegrationScopeService.resetCache();
            $scope.loadIntegrationScopes(true);
            $scope.noMoreData = false;
        };

        $scope.edit = function (id) {
            $location.path('/Integrations/IntegrationScope/' + $scope.integrationID + '/' + id);
        };

        $scope.goList = function () {
            $location.path('/Integrations/');
        };

        function DialogController($scope, $uibModalInstance, $timeout, data, TranslationService) {
            $scope.scopeItem = data;
            $scope.translation = TranslationService.getActiveTranslation();

            $scope.save = function (isSaveAndIntegrate) {
                var object = { scopeItem: $scope.scopeItem, isSaveAndIntegrate: isSaveAndIntegrate };
                $uibModalInstance.close(object);
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            $scope.codemirrorRefresh = 0;

            $scope.codemirrorReload = function () {
                $timeout(function () {
                    $scope.codemirrorRefresh += 1;
                }, 200);
            };
        }

        $scope.getScopeName = function (prefix) {
            var today = new Date();
            var scopeName = prefix + today.toLocaleDateString('pt-BR') + ' ' + today.toLocaleTimeString('pt-BR');
            return scopeName;
        };
       

        $scope.tryAddWebApi = function () {
            console.log('tryAddWebApi');
            console.log($scope.listItem);
            var scopeItem = {
                ScopeName: $scope.getScopeName('Web_Request: '),
                RequestParams: $scope.listItem.RequestParams,
                ParamStartDateMode: $scope.listItem.ParamStartDateMode,
                ParamEndDateMode: $scope.listItem.ParamEndDateMode,
                ParamStartRange: $scope.listItem.ParamStartRangeDefault,
                ParamEndRange: $scope.listItem.ParamEndRangeDefault,
                IsAdding: true,
                ExecType: 'Manual',
            };

            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Integrations/scopeEditName.html',
                controller: 'ScopeEditNameController',
                size: 'md',
                resolve: {
                    scopeItem: function () { return scopeItem; },
                    translation: function () { return $scope.translation; }
                }
            });

            modalInstance.result.then(function (item) {
                //$scope.update(item);
                $scope.addWebApi(item.ScopeName, item.RequestParamOverride, item.ParamStartDate, item.ParamEndDate, item.ParamStartRange, item.ParamEndRange, item.ExecType);
            });
        };

        $scope.addWebApi = function (scopeName, requestParamOverride, paramStartDate, paramEndDate, paramStartRange, paramEndRange, execType) {
            //console.log('addWebApi ' + scopeName + ' ' + requestParamValues);

            //Pedir parametros....
            var scopeItem = IntegrationScopeService.createNewScope(null, $scope.integrationID, '', '');
            //var today = new Date();
            scopeItem.ScopeName = scopeName;
            scopeItem.ScopeValues = '';
            scopeItem.ParamStartRange = paramStartRange;
            scopeItem.ParamEndRange = paramEndRange;
            scopeItem.ExecType = execType;

            //debugger;

            if (requestParamOverride) {
                scopeItem.RequestParamOverride = requestParamOverride;
                scopeItem.ParamStartDate = paramStartDate;
                scopeItem.ParamEndDate = paramEndDate;
            }

            console.log('addWebApi.scopeItem');
            //console.log(scopeItem);

            IntegrationScopeService.save(scopeItem).then(function (data) {
                console.log('addWebApi.save');
                //console.log(data);
                IntegrationScopeService.processData(data.ScopeID).then(
                    function (data) {
                        console.log('addWebApi.processData!');
                        //console.log(data);
                        $rootScope.$broadcast('onIntegrationProcess', data);
                    }
                );
                $scope.edit(data.ScopeID);
            });
        };        


        $scope.addNew = function (scopeItem) {
            IntegrationScopeService.resetCache();
            var toastID = ToastService.createToast('Integração', 'Adicionando Integração', 8000, 'wait');
            IntegrationScopeService.save(scopeItem).then(function (data) {
                ToastService.updateToast(toastID, 'Integração', 'Processando integração', 8000, 'wait');
                IntegrationScopeService.processData(data.ScopeID).then(function (data1) {
                    console.log('processed!');
                    ToastService.removeToast(toastID);
                });
                $scope.edit(data.ScopeID);
            });
        }

        $scope.tryAddNew = function () {
            //$scope.showEditModal();
            console.log('tryAddNew');

            $scope.scopeItem = $scope.listItem;
            if ($scope.scopeItem.InOrOut == 'JOB') {
                $scope.addNew($scope.scopeItem);
                return;
            }

            var scopeName = $scope.getScopeName('Request: ');
            $scope.scopeItem.ScopeName = scopeName;

            //var propertyToRead = 'ScopeValues';
            var propertyToRead = 'RequestBody';
            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Integrations/scopeEditValues.html',
                controller: 'ScopeEditValuesController',
                size: 'xl',
                resolve: {
                    scopeItem: function () { return $scope.scopeItem; },
                    propertyToRead: function () { return propertyToRead; },
                    translation: function () { return $scope.translation; }
                }
            });

            modalInstance.result.then(function (scopeItem) {
                $scope.addNew(scopeItem);
                /*
                IntegrationScopeService.resetCache();
                var toastID = ToastService.createToast('Integração', 'Adicionando Integração', 8000, 'wait');
                IntegrationScopeService.save(scopeItem).then(function (data) {
                    ToastService.updateToast(toastID, 'Integração', 'Processando integração', 8000, 'wait');
                    IntegrationScopeService.processData(data.ScopeID).then(function (data1) {
                        console.log('processed!');
                        ToastService.removeToast(toastID);
                    });
                    $scope.edit(data.ScopeID);
                });
                */
            });            
        }

        $scope.showEditModal = function (ev, propertyToRead) {
            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Integrations/scopeEditValues.html',
                controller: 'ScopeEditValuesController',
                size: 'xl',
                resolve: {
                    scopeItem: function () { return $scope.scopeItem; },
                    propertyToRead: function () { return propertyToRead; },
                    translation: function () { return $scope.translation; }
                }
            });

            modalInstance.result.then(function (scopeItem) {
                IntegrationScopeService.resetCache();
                $scope.update(IntegrationScopeService.updatePreviewValues(scopeItem));
            });
        };


    }]);